"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _core = require("@material-ui/core");
var _material = require("@heron-web/material");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Ticket journey selection grid
 * 
 * @package HOPS
 * @subpackage Tickets
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class TicketJourneyGrid extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Flex, {
      gap: 1,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.String, {
        bold: true,
        noFlex: true,
        str: this.props.label
      }), this.props.journeys?.length ? this.renderJourneys() : /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.String, {
        color: "textSecondary",
        noFlex: true,
        str: this.props.noJourneysMessage || "No journeys available."
      })]
    });
  }

  /**
   * Render the journeys.
   * 
   * @return {ReactNode}
   */
  renderJourneys() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonGrid, {
      color: this.props.color,
      items: this.journeyItems,
      name: this.props.name,
      onChange: this.props.onSelect,
      size: "7.5rem",
      value: this.props.selectedJourneyId
    });
  }

  /**
   * Get whether we have availability for a journey.
   *
   * @param {Object} journey
   * @return {Boolean}
   */
  hasJourneyAvailability(journey) {
    let unavailable = this.props.forceAllUnavailable;
    const availability = journey.Train?.Availability;
    if (availability !== null && !unavailable) {
      unavailable = availability < this.props.requiredAvailability;
    }
    return journey.Id === this.props.selectedJourneyId || !unavailable;
  }

  /**
   * Get journey items to display in the `ButtonGrid`.
   *
   * @return {Array<Object>}
   */
  get journeyItems() {
    const currentTime = new _moment.default().format("YYYY-MM-DD HH:mm:ss");
    return this.props.journeys.map(journey => {
      const label = this.constructor.getJourneyLabel(journey);
      const journeyTime = `${journey.Train?.Date} ${label}:00`;
      const hasAvailability = this.hasJourneyAvailability(journey);
      const trainCanceled = journey.Train?.ScheduleType === "CAN";
      const className = [trainCanceled ? this.props.classes.cancelled : undefined, !hasAvailability ? this.props.classes.unavailable : undefined, journeyTime < currentTime || this.props.forceAllPast ? this.props.classes.past : undefined].filter(c => c).join(" ");
      return {
        id: journey.Id,
        value: journey,
        label,
        className
      };
    });
  }

  /**
   * Get the label to show for a journey.
   *
   * @param {Object} journey
   * @return {String}
   */
  static getJourneyLabel(journey) {
    return (journey.Departure?.DepartureTime || "").substring(0, 5);
  }

  /**
   * Styles.
   *
   * @param {Object} theme Material UI theme object
   * @return {Object}
   */
  static styles(theme) {
    return {
      past: {
        color: `${(0, _colorManipulator.fade)("#aaaaaa", 0.8)} !important`
      },
      unavailable: {
        backgroundColor: `${(0, _colorManipulator.fade)("#aaaaaa", 0.1)} !important`,
        color: (0, _colorManipulator.fade)(theme.palette.text.primary, 0.4)
      },
      cancelled: {
        backgroundColor: `${(0, _colorManipulator.fade)("#ff0000", 0.1)} !important`,
        color: (0, _colorManipulator.fade)("#ff0000", 0.4),
        textDecoration: "line-through"
      }
    };
  }
  static propTypes = {
    classes: _propTypes.default.object,
    color: _propTypes.default.oneOf(["primary", "secondary"]),
    forceAllPast: _propTypes.default.bool,
    forceAllUnavailable: _propTypes.default.bool,
    journeys: _propTypes.default.array,
    label: _propTypes.default.string,
    name: _propTypes.default.string,
    noJourneysMessage: _propTypes.default.string,
    onSelect: _propTypes.default.func,
    requiredAvailability: _propTypes.default.number,
    selectedJourneyId: _propTypes.default.string,
    showScheduleType: _propTypes.default.bool
  };
  static defaultProps = {
    color: "primary",
    forceAllPast: false,
    forceAllUnavailable: false,
    noJourneysMessage: "No journeys available.",
    requiredAvailability: 0,
    showScheduleType: false
  };
}
var _default = (0, _core.withStyles)(TicketJourneyGrid.styles)(TicketJourneyGrid);
exports.default = _default;